// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"322":"a9ae311a","327":"9091fb3c","453":"e22fbc8e","769":"e6dca361"}[chunkId] + ".chunk.js";
};